import React from 'react';

import useCartState from '../../../hooks/useCartState';
import ConsumerFinanceWidget from '../../../product/components/consumer-finance-widget';

export default () => {
    const { cartInfo } = useCartState();
    const { cartView, cartDetails } = cartInfo || {};
    const { customerOrderNumber, x_subTotal: salePrice } = cartView || {};
    const { showHPFinancingWidget } = cartDetails || {};
    const product = {
        sku: customerOrderNumber,
        HPFinance_Promo: true,
    };
    const price = { salePrice };

    if ((!customerOrderNumber && !salePrice) || !showHPFinancingWidget) {
        return null;
    }

    return <ConsumerFinanceWidget product={product} price={price} checkLimit={false} />;
};
